import React, { memo } from "react";
import { Spinner, Text, useTheme } from "@bookingcom/bui-react";
import { t, useI18n } from "@bookingcom/lingojs-react";
import Frame from "../../../../components/elements/Frame/Frame.js";
import { useSelector } from "react-redux";
import { getFlightDetailsFetchStatus } from "../../../../store/flightDetails/selectors.js";
export const LoadingAncillariesPrice = memo(function _LoadingAncillariesPrice({ type, price, productTitle }) {
    const i18n = useI18n();
    const theme = useTheme();
    const fetchStatus = useSelector(getFlightDetailsFetchStatus);
    switch (fetchStatus) {
        case "loading":
            return (React.createElement(React.Fragment, null,
                React.createElement(Text, { variant: "body_2" }, price),
                React.createElement(Frame, { direction: "row" },
                    React.createElement(Frame, { mr: 2, attributes: { style: { alignSelf: "center" } } },
                        React.createElement(Spinner, { size: "small" })),
                    React.createElement(Frame, { attributes: { style: { color: theme.colors.color_foreground_alt } } },
                        React.createElement(Text, { variant: "small_1", color: "neutral_alt" }, getPriceLoadingText(type, i18n))))));
        case "failed":
            return (React.createElement(Frame, { attributes: { style: { color: theme.colors.color_foreground_alt } } },
                React.createElement(Text, { variant: "body_2" }, getPriceLoadingErrorText(type, i18n)),
                ";"));
        case "success":
            return productTitle ? (React.createElement(Text, { "aria-label": `${productTitle}: ${price}`, variant: "body_2" }, price)) : (React.createElement(Text, { variant: "body_2" }, price));
        default:
            return React.createElement(Text, { variant: "body_2" }, price);
    }
});
const getPriceLoadingText = (type, i18n) => {
    switch (type) {
        case "checkedInBaggage":
            return i18n.trans(t("flights_fd_extra_checked_bag_price_updating"));
        default:
            return i18n.trans(t("flights_fd_extra_cabin_bag_price_updating"));
    }
};
const getPriceLoadingErrorText = (type, i18n) => {
    switch (type) {
        case "checkedInBaggage":
            return i18n.trans(t("flights_fd_extra_checked_bag_price_updating_failed"));
        default:
            return i18n.trans(t("flights_fd_extra_cabin_bag_price_updating_failed"));
    }
};
